import React from "react"

import { LocalizedLink as Link } from "gatsby-theme-i18n"
import { useIntl } from "react-intl"

const SupportNavigation = ({ location }) => {
  const page = location.pathname.split("/").pop()
  return (
    <ul className="nav nav-pills mb-2">
      <NavLink page={page} to="support" title="Welcome" />
      <NavLink page={page} to="support_articles" title="Support Articles" />
    </ul>
  )
}

const NavLink = ({ page, to, title }) => {
  const intl = useIntl()
  return (
    <Link
      to={"/" + to}
      className={"nav-link " + (page == to ? "active" : "") + " mr-1 mb-1"}
    >
      {intl.formatMessage({ id: title })}
    </Link>
  )
}

export default SupportNavigation
